import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Falta el texto alternativo para esta imagen',
    noAnswers: 'No hay opción de respuesta, por favor, haz clic en "siguiente" para continuar.',
    placeholder: 'Especifique...',
    pleaseSelect: 'Seleccione...',
    rotateLandscape: 'Desactive el bloqueo de orientación en su teléfono y gírelo a horizontal para continuar.',
    rotatePortrait: 'Gire el teléfono de horizontal a vertical para continuar.',
    ir: {
      selectWebCam:
        'Selecciona una webcam (si está disponible) o haz clic en "Navegar" para subirla desde tu dispositivo',
      noWebCam: 'No se ha detectado ninguna cámara web',
      accessCamUpload: 'ACCEDER A LA CÁMARA/SUBIR',
      browse: 'NAVEGAR',
      uploadPhoto: 'Sube una foto',
      instead: 'en vez de',
      startOver: 'Vuelva a empezar',
      capture: 'TOMA',
      allDone: '¡Todo hecho!',
      somethingWrong: 'Lo sentimos, algo ha ido mal. Por favor, inténtalo de nuevo más tarde.',
      analyzing: 'Analizando la imagen, por favor, espera',
      couldntRead: 'Lo sentimos, ¡no hemos podido leer el código!',
      couldntProcess: 'Lo sentimos, ¡no hemos podido procesar tu imagen!',
      moveOn: 'Por favor, inténtalo de nuevo o sube tu foto y continúa',
      tryAgain: 'Por favor, inténtalo de nuevo',
      dataReceived: '¡Información recibida!',
      enterManually: 'Por favor, inténtalo de nuevo o introduce la información manualmente abajo',
      positionQR:
        'Por favor, sitúa el código QR en frente de tu cámara para que encaje en el marco rojo o súbelo desde tu ordenador',
      submit: 'PRESENTAR',
      cantAnalyze:
        'Atención: no pudimos reproducir esta imagen. Por favor, intenta volver a subir un formato de imagen más genérico (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Lo sentimos, no somos compatibles con este formato de archivo. Por favor, sube un tipo de imagen compatible (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'No se ha detectado ninguna cámara web',
      uploadVideo: 'Subir un vídeo',
      skip: '¿Omitir?',
      accessCamUpload: 'ACCEDER A LA CÁMARA/SUBIR',
      browse: 'NAVEGAR',
      instead: 'en vez de',
      or: 'o',
      stopRecording: 'Parar la grabación',
      willBeStopped: 'La grabación parará en 5 minutos',
      stopOnDone: '¡Pare la grabación cuando haya terminado!',
      record: 'GRABAR',
      somethingWrong: 'Lo sentimos, algo ha ido mal. Por favor, inténtalo de nuevo más tarde.',
      microphone: 'Micrófono',
      camera: 'Cámara Web',
      selectMicrophone: 'Elige tu micrófono',
      selectCam: 'Elige tu cámara web',
      upload: 'SUBIR',
      playback: 'Reproducción',
      stopPlayback: 'DETENER LA REPRODUCCIÓN',
      submit: 'PRESENTAR',
      startOver: 'Vuelva a empezar',
      allDone: '¡Todo hecho!',
      alternativeRecordSpan:
        'Por favor, cargue un vídeo clip desde su dispositivo informático.<br/>Alternativamente,  &nbsp;',
      alrenativeRecordHref: 'puede grabar el vídeo con una webcam.',
      cantAnalyze:
        'Atención: no pudimos reproducir este vídeo. Por favor, intenta volver a subirlo o elige un formato de vídeo más genérico (MP4, M4V, WEBPM)',
      wrongFormat:
        'Lo sentimos, no somos compatibles con este formato de archivo. Por favor, sube un tipo de vídeo compatible (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'ESCOGER',
      pleaseChoose: 'Por favor, escoge',
      this: 'ESTE',
      one: 'uno',
      myChoice: 'Mi SELECCIÓN'
    },
    hm: {
      addComment: 'Por favor, añada un comentario a continuación',
      commentMandatoryPlaceHolder: 'Es obligatorio añadir un comentario… ',
      commentOptionalPlaceHolder: 'Es opcional añadir un comentario… ',
      dragPin: 'Arrastrar para reposicionar (Haga clic o toque prolongado para un anclaje de precisión).',
      removePin: 'Arrastre fuera de la imagen para eliminarla.',
      editComment: 'Haga clic o toque el pin para editar el comentario.',
      addPin: 'Por favor, arrastre el pin desde el panel de abajo y suéltelo en el lugar que quiera de la imagen.',
      addPins:
        'Por favor, arrastre los pines desde el panel de abajo y suéltelos en el lugar de su elección en la imagen. ',
      leavePins: (minPoints, maxPoints) =>
        `Por favor, deje al menos ${minPoints} pero no más de ${maxPoints} pines de cada tipo.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Por favor, deje al menos ${minPoints} pero no más de ${maxPoints} pines.`,
      leavePinsWithOff: maxPoints =>
        `Por favor, no deje más de ${maxPoints} pines de cada tipo o haga clic en Siguiente para omitirlo.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Por favor, no deje más de ${maxPoints} pines o haga clic en Siguiente para omitirlo.`,
      leavePinWithOff: 'Por favor, no deje más de 1 pin de cada tipo o haga clic en Siguiente para omitirlo.',
      leavePinPerPageWithOff: 'Por favor, no deje más de 1 pin o haga clic en Siguiente para omitirlo.',
      leaveExactlyPin: 'Por favor, deje 1 pin de cada tipo.',
      leaveExactlyPinPerPage: 'Por favor, deje 1 pin.',
      leaveExactlyPins: maxPoints => `Por favor, deje ${maxPoints} pines de cada tipo.`,
      leaveExactlyPinsPerPage: maxPoints => `Por favor, deje ${maxPoints} pines.`,
      leaveComment: 'Escriba debajo de la imagen para dejar un comentario.',
      noAnswers: 'Sin opción de respuesta, por favor haga clic en el siguiente para continuar.',
      outOfPins: 'Se le acabaron los pines',
      pinsBehavior: 'A medida que se desplace por la imagen, verá áreas que se resaltarán con un solo pin.',
      clusters: 'Solo podrá colocar pines en estas áreas resaltadas.',
      contentAware: 'Puede soltar pines dentro o fuera de las áreas resaltadas.'
    },
    mp: {
      expand_note: 'Pase el cursor por encima o haga clic en la o las imágenes para expandir',
      rb_note: rows => `Seleccione solo 1 respuesta por cada elemento${rows ? ' siguiente' : ''}:`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return 'Marque todas las opciones que correspondan:'
        } else if (min === max) {
          return `Seleccione ${min !== 1 ? 'hasta' : 'solo'} ${min} respuesta${min !== 1 ? 's' : ''} por elemento${
            rows ? ' a continuación' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Seleccione al menos ${min} respuesta pero no más de ${max} por elemento${
            rows ? ' a continuación' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Seleccione al menos ${min} respuesta por elemento${rows ? ' a continuación' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Seleccione no más de ${max} respuesta por elemento${rows ? ' a continuación' : ''}:`
        } else {
          return 'Marque todas las opciones que correspondan:'
        }
      }
    },
    sh: {
      note: 'Haz clic en un producto para aumentarlo y añadirlo a tu carro virtual si lo comprarías en la tienda',
      amazonNote: 'Haz clic en un producto para ampliarlo y añadirlo a tu cesta virtual.',
      fullCart: '¡Tu carro está lleno!',
      qty: 'CANTIDAD',
      addToCart: 'AÑADIR AL CARRO',
      deleteFromCart: 'BORRAR',
      each: 'cada',
      items: 'elementos',
      emptyCard: 'Tu carro está vacío',
      total: 'Carro',
      clearCart: 'Vaciar el carro',
      backToStore: 'Volver a la tienda',
      na: 'Ninguno de estos',
      next: 'SIGUIENTE',
      maxCartCountError: max => `No agregue más de ${max} productos a su carrito`,
      scrollError: `Desplácese completamente hacia la izquierda y hacia la derecha para continuar con la encuesta. `,
      maxSpentError: max => `No gaste más de ${max}.`,
      maxProductCountError: max => `No agregue más de una cantidad de ${max} a su carrito para cada producto.`
    },
    rb: {
      note: 'Seleccione solo 1 elemento:'
    },
    vo: {
      note: 'Por favor, mira el video hasta el final'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `Seleccione ${min !== 1 ? 'cualquier' : 'solo'} ${min} elemento${min !== 1 ? 's' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Seleccione al menos ${min} elemento${min !== 1 ? 's' : ''} pero no más de ${max}:`
        } else if (5000 === max && min > 0) {
          return `Seleccione al menos ${min} elemento${min !== 1 ? 's' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Seleccione no más de ${max} elemento${max !== 1 ? 's' : ''}:`
        } else {
          return 'Marque todas las opciones que correspondan:'
        }
      }
    },
    oe: {
      na: 'No aplica',
      note: (min, max, optional) => {
        if (min === max) {
          return `Escriba ${1 !== min ? 'cualquier' : 'exactamente'} ${min} carácter${1 !== min ? 'es' : ''}${
            optional ? ' (opcional)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Escriba al menos ${min} carácter${1 !== min ? 'es' : ''} pero no más de ${max}${
            optional ? ' (opcional)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Escriba al menos ${min} carácter${1 !== min ? 'es' : ''}${optional ? ' (opcional)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `No escriba más de ${max} carácter${1 !== min ? 'es' : ''}${optional ? ' (opcional)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Por favor, rellena los siguientes campos:'
    },
    mx: {
      note: 'Por favor, mueve los deslizadores resaltados para continuar',
      dragSlider: 'Arrastre hacia la izquierda o la derecha para responder'
    },
    psc: {
      dragLeftRight: 'Arrastre hacia la izquierda o la derecha para responder'
    },
    ps: {
      note: value => `Por favor distribute restante ${value} entre los puntos que siguen`,
      allDone: '¡Todo hecho!',
      total: `Total:`,
      dragSlider: 'Arrastre hacia la izquierda o la derecha para responder'
    },
    cx: {
      note: 'Empiece a escribir su respuesta para desplazarse automáticamente o selecciónela manualmente.'
    },
    ro: {
      note: 'Arrastre hacia arriba o hacia abajo para cambiar el orden de:'
    },
    md: {
      note1:
        'Por favor, haga clic o toque sobre el ítem de su primera elección<br/>Haga clic o toque de nuevo para desactivar la elección.',
      note2:
        'Por favor, ahora haga clic o toque sobre el ítem de su última elección<br/>Haga clic o toque de nuevo para desactivar la elección.',
      note3:
        '¡Gracias! Continúe con la siguiente pregunta<br/>o haga clic o toque sobre cualquier ítem no seleccionado para empezar de nuevo.'
    },
    aro: {
      note: 'Elige uno de cada pareja'
    },
    wd: {
      note: 'Asegúrate de que cada valor posterior es mayor que el anterior.'
    },
    emd: {
      note: 'Por favor, mira el video hasta el final',
      noAnswers: 'No hay opción de respuesta, por favor, haz clic en "siguiente" para continuar.',
      start: 'Pulsa y sostén para empezar',
      resume: 'Pulsa y sostén para continuar',
      continue: '¡Ya estás listo! <br /> Haz clic en Siguiente para continuar',
      continueMobile: '¡Estás listo! <br /> Haga clic AQUÍ para continuar',
      training: {
        session: 'Sesión de capacitación',
        note: 'Por favor, termina el entrenamiento',
        moveLeft: 'Por favor, arrastra el dial a la izquierda hasta el final',
        moveBottom: 'Por favor, arrastra el dial hasta abajo',
        moveRight: 'Ahora, por favor, arrastra el dial a la derecha hasta el final',
        moveTop: 'Ahora, por favor, arrastra el dial hasta arriba',
        success: '¡Bien hecho!'
      }
    },
    sft: {
      noAnswers: 'No hay opción de respuesta, por favor, haz clic en "siguiente" para continuar.',
      note: 'Por favor, responde lo más rápido posible con la respuesta que intuitivamente crees que es correcta',
      finish: '¡Ya has terminado! <br /> Por favor, haz clic en Siguiente para continuar',
      training: {
        start:
          '<p>Esta pregunta te mostrará rápidamente distintas palabras y requerirá que te concentres. ' +
          'Tendrás que reaccionar rápidamente para contestar. </p> <p>¿Preparado para practicar?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Pulsa "{buttonLeft}"`
            : (mouse ? `Haz clic en "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Dale a la tecla "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Pulsa "{buttonRight}"`
            : (mouse ? `Haz clic en "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Dale a la tecla "{keyBtnRight}"` : ''),
        fail: () => 'Demasiado lento',
        success: () => '¡Genial!',
        finish: () =>
          '<p><strong>¡Excelente!</strong></p><p>Por favor, asegúrate de que nada<br />' +
          'te distraiga durante<br/> los próximos 2-3 minutos. </p><p>Haz clic en Siguiente para empezar cuando estés listo. </p>'
      },
      buttons: {
        start: 'Empezar',
        yesno: {
          left: 'Sí',
          right: 'No'
        },
        matches: {
          left: 'Coincide',
          right: 'No coincide'
        },
        fits: {
          left: 'Encaja',
          right: 'No encaja'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
